import React, { useState, useEffect, useCallback } from 'react';
import _ from 'lodash';
import MaterialSearch from '../MaterialSearch';

const KanbanSearch = ({ onSearch }) => {
  const [value, setValue] = useState('');

  const handleChange = event => {
    setValue(event.target.value);
  };

  const debouncedOnSearch = useCallback(_.debounce(onSearch, 500), []);

  useEffect(() => {
    debouncedOnSearch(value);
  }, [value]);

  return (
    <div className="kanban-search">
      <MaterialSearch
        onChange={handleChange}
        onClear={() => setValue('')}
        value={value}
        showResults={false}
        clearLeft
      />
    </div>
  );
};

export default KanbanSearch;
